export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/forbes.80d75f57.svg","height":20,"width":81,"blurWidth":0,"blurHeight":0};